import { render, staticRenderFns } from "./Child.vue?vue&type=template&id=9512aa70"
import script from "./Child.vue?vue&type=script&lang=js"
export * from "./Child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports